import React, { useState, useCallback } from "react";
import { useParams } from "react-router-dom";
import {
  FantasyArticlesCreateButton,
  FantasyArticlesHeader,
  FantasyArticlesTitle,
} from "./styles";

import ArticlesDisplay from "../ArticlesDisplay";
import Button from "../../../Button";
import GroupCheck from "../../../GroupCheck";

export default function FantasyArticles() {
  const { sport } = useParams();
  const [searchText, setSearchText] = useState(null);
  const [activeSearch, setActiveSearch] = useState(null);

  const categories = ["fantasy"];

  if (sport) {
    categories.push(sport.toLowerCase());
  }

  return (
    <>
      <FantasyArticlesHeader>
        <GroupCheck groupName="Content Writer">
          <FantasyArticlesCreateButton href="/article/create">
            New Article
          </FantasyArticlesCreateButton>
          <FantasyArticlesCreateButton href="/article/drafts">
            Drafts
          </FantasyArticlesCreateButton>
        </GroupCheck>
        <FantasyArticlesTitle>
          Fantasy {sport !== undefined ? sport.toUpperCase() : ""} Articles
        </FantasyArticlesTitle>
        <form
          onSubmit={(e) => {
            e.preventDefault();
            setActiveSearch(searchText);
          }}
        >
          <input
            type="text"
            className="form-input"
            placeholder={`Search fantasy${
              sport !== undefined ? " " + sport.toUpperCase() + " " : " "
            }articles...`}
            onKeyUp={(e) => {
              setSearchText(e.target.value);
            }}
          />
          <br />
          <br />
          <Button form={true} type="submit">
            Search
          </Button>
        </form>
        <hr />
      </FantasyArticlesHeader>
      <React.Suspense fallback="">
        <ArticlesDisplay activeSearch={activeSearch} categories={categories} />
      </React.Suspense>
    </>
  );
}
